import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Alert, Button, Input, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import InputAsyncMulti from './_InputAsyncMulti';
import Loading from './Loading';
import { startChat, uploadChatImage, userSuggestions /* , deleteChatImage */ } from '../../utils/Api';

class StartChat extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: true,
      modal: false,
      users: [],
      errorMessage: '',
    };

    this.filesSizeLimit = 5242880; // 5 MB

    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleUsers = this.handleUsers.bind(this);
    this.handleAddChat = this.handleAddChat.bind(this);
    this.handleUploadImage = this.handleUploadImage.bind(this);
    // this.handleDeleteImage = this.handleDeleteImage.bind(this);
  }

  toggle() {
    const { modal } = this.state;
    this.setState({ modal: !modal });
  }

  handleChange({ target }) {
    this.setState({ [target.id]: target.value });
  }

  handleUsers(users) {
    this.setState({ users });
  }

  handleAddChat() {
    const { users, title, file_id } = this.state;
    const { onAddComplete } = this.props;
    this.setState({ isLoaded: false });
    startChat({
      ...(users.length ? { users } : {}),
      ...(title ? { title } : {}),
      ...(file_id ? { file_id } : {}),
    }).then(({ id, error }) => {
      if (error && error.msg) {
        this.setState({
          isLoaded: true,
          errorMessage: error.msg,
        });
      } else {
        this.setState({
          isLoaded: true,
          modal: false,
          file_id: null,
          title: '',
          users: [],
        });
        onAddComplete(id);
      }
    });
  }

  handleUploadImage({ target }) {
    if (target.files[0].size > this.filesSizeLimit) {
      this.setState({
        errorMessage: this.props.intl.formatMessage({ id: 'error_filesizeExceeded' }),
      });
      return;
    }
    this.setState({
      isLoaded: false,
      errorMessage: null,
    });
    uploadChatImage(target.files[0]).then(({ id, original_name, link }) => {
      this.setState({
        file_id: id,
        original_name,
        file_link: link,
        isLoaded: true,
      });
    });
  }

  // handleDeleteImage() {
  //   const { start } = this.state;
  //   if (window.confirm('Are you sure?')) {
  //     this.setState({ isLoaded: false });
  //     deleteChatImage(start.file_id).then(() => {
  //       this.setState({
  //         start: {
  //           ...start,
  //           file_id: null,
  //         },
  //         isLoaded: false,
  //       });
  //     });
  //   }
  // }

  render() {
    const { isLoaded, modal, errorMessage, users } = this.state;
    const { intl } = this.props;

    return (
      <React.Fragment>
        <button type="button" className="btn btn-primary mrg-md fr" onClick={this.toggle}>
          <FormattedMessage id="chats_newChat" />
        </button>
        <div className="clear" />
        <Modal isOpen={modal} toggle={this.toggle} className="modal-lg">
          {!isLoaded && <Loading />}
          <ModalHeader toggle={this.toggle}><FormattedMessage id="chats_newChat" /></ModalHeader>
          <ModalBody>
            {errorMessage && <Alert color="danger"><FormattedMessage id={errorMessage} /></Alert>}
            <InputAsyncMulti
              values={users}
              search={searchString => userSuggestions(searchString)}
              onChange={this.handleUsers}
            />
            {users.length > 1 &&
            <span>*<Input
              id="title"
              placeholder={intl.formatMessage({ id: 'chats_titlePlaceholder' })}
              value={this.state.title || ''}
              onChange={this.handleChange}
            /></span>}
            <Input
              id="image"
              type="file"
              onChange={this.handleUploadImage}
              style={{ position: 'absolute', top: -1000 }}
              accept=".png, .jpeg, .jpg, .gif"
            />
            {this.state.file_id &&
            <img
              src={this.state.file_link}
              alt={this.state.original_name || ''}
              style={{ maxWidth: 64, maxHeight: 64 }}
            />}
          </ModalBody>
          <ModalFooter>
            {users.length > 1 &&
            <Button
              color="primary"
              onClick={() => document.getElementById('image').click()}
            >Upload Image</Button>}
            <Button color="primary" onClick={this.handleAddChat}><FormattedMessage id="chats_startChat" /></Button>
            <Button color="secondary" onClick={this.toggle}><FormattedMessage id="overall_input_cancel" /></Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

StartChat.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  onAddComplete: PropTypes.func.isRequired,
};

export default injectIntl(StartChat);



// WEBPACK FOOTER //
// ./src/views/_Chats/StartChat.js